import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";

type CB = { onSuccess?: (r: any) => void; onError?: (e: any) => void };

export const usePQQList = (cid: number, params: any = {}) =>
  useQuery({
    queryKey: ["pqq", cid, params],
    queryFn: () => client.get(API_ENDPOINTS.PQQ_LIST(cid), { params }).then((r) => r.data.data as { data: any[]; total: number }),
    enabled: !!cid,
    refetchOnWindowFocus: false,
  });

export const usePQQCreate = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, data }: { cid: number; data: any }) =>
      client.post(API_ENDPOINTS.PQQ_CREATE(cid), data),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["pqq", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const usePQQUpdate = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, id, data }: { cid: number; id: number; data: any }) =>
      client.put(API_ENDPOINTS.PQQ_UPDATE(cid, id), data),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["pqq", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};

export const usePQQDelete = ({ onSuccess, onError }: CB = {}) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cid, id }: { cid: number; id: number }) =>
      client.delete(API_ENDPOINTS.PQQ_DELETE(cid, id)),
    onSuccess: (r, v) => { qc.invalidateQueries({ queryKey: ["pqq", v.cid] }); onSuccess?.(r); },
    onError: (e) => onError?.(e),
  });
};
